import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthLayout } from './components/layout/AuthLayout';
import { AppLayout } from "./components/layout/AppLayout";
import { SignInPage } from './pages/SignInPage';
import { OnboardingPage } from "./pages/OnboardingPage";
import { ChatPage } from "./pages/ChatPage";
import { SetupPage } from "./pages/SetupPage";
import { MonitorPage } from "./pages/MonitorPage";
import { BrowserPage } from "./pages/BrowserPage";
import { PlansPage } from './pages/PlansPage';
import { ExtendPage } from './pages/ExtendPage';
import { ReportPage } from './pages/ReportPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { SettingsPage } from './pages/SettingsPage';
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { OAuthPopupCallback } from "./pages/OAuthPopupCallback";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useAuthStore } from "./stores/authStore";

export default function App() {
  const checkSession = useAuthStore((s) => s.checkSession);
  const token = useAuthStore((s) => s.token);

  // Check session validity on app load if token exists
  useEffect(() => {
    if (token) {
      checkSession();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Routes>
      {/* Sign-in page with minimal header */}
      <Route element={<AuthLayout />}>
        <Route path="/" element={<SignInPage />} />
      </Route>

      {/* Auth callback (handles ?token= from OAuth/OTP) */}
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      {/* OAuth popup callback (used by re-auth flow in chat) */}
      <Route path="/oauth/popup-callback" element={<OAuthPopupCallback />} />

      {/* Onboarding (standalone, no layout) */}
      <Route path="/onboarding" element={<OnboardingPage />} />

      {/* Protected routes with app layout (sidebar navigation) */}
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/monitor" element={<MonitorPage />} />
        <Route path="/browser" element={<BrowserPage />} />
        <Route path="/changelog" element={<PlansPage />} />
        <Route path="/automate" element={<ExtendPage />} />
        <Route path="/report" element={<ReportPage />} />
        <Route path="/audit" element={<AuditLogPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      {/* Catch-all: redirect to sign-in */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
